"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePatientPublicChatBan = void 0;
var _ = require("./");
var usePatientPublicChatBan = function usePatientPublicChatBan(patientId) {
  var requestRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _useRequest = (0, _.useRequest)((0, _.getUserPublicChatBanUrl)(patientId), {
      ready: !!patientId && requestRequired
    }),
    activePublicChatBan = _useRequest.data,
    loading = _useRequest.loading,
    refresh = _useRequest.refresh;
  return {
    banned: !!activePublicChatBan,
    banExpiresAt: activePublicChatBan === null || activePublicChatBan === void 0 ? void 0 : activePublicChatBan.banExpiresAt,
    loading: loading,
    refresh: refresh
  };
};
exports.usePatientPublicChatBan = usePatientPublicChatBan;